/**
 * Custom path serializer that doesn't encode colons in path parameters.
 * This is needed for CRN (Cloud Resource Name) identifiers like 'crn:pathway:plan:xxx'.
 *
 * The default generated path serializer always calls encodeURIComponent, but we need
 * to preserve colons and other reserved characters in CRN identifiers.
 *
 * This is in a separate file to avoid circular dependency issues with api.ts
 * (which is imported by the generated client files).
 */
export const customPathSerializer = ({
  path,
  url: _url,
}: {
  path: Record<string, unknown>;
  url: string;
}): string => {
  let url = _url;
  const PATH_PARAM_RE = /\{[^{}]+\}/g;
  const matches = _url.match(PATH_PARAM_RE);

  if (matches) {
    for (const match of matches) {
      const name = match.substring(1, match.length - 1);
      const value = path[name];

      if (value == null) continue;

      const segment = String(value as string | number);

      // For CRN identifiers and other path params, don't encode colons
      // Only encode characters that are actually problematic in URLs
      const replaceValue = segment
        .replace(/%/g, '%25') // Encode % first
        .replace(/#/g, '%23') // Encode hash
        .replace(/\?/g, '%3F') // Encode question mark
        .replace(/ /g, '%20') // Encode space
        .replace(/\[/g, '%5B') // Encode [
        .replace(/\]/g, '%5D'); // Encode ]
      // Note: We intentionally do NOT encode colons (:) for CRN support

      url = url.replace(match, replaceValue);
    }
  }

  return url;
};
